// extracted by mini-css-extract-plugin
export default {"eligibilitySection":"styles_eligibilitySection__asbyb"};